import { Quote } from "lucide-react";
import { useLang } from "@/i18n";
import { Reveal, Kicker } from "@/components/Reveal";

// SAMPLE guest quotes — replace with real traveller testimonials supplied by the owner.
const REVIEWS = [
  {
    quote: {
      en: "The Golden Triangle with Varanasi was flawless — our chauffeur felt like family, and the Ganga Aarti from our private boat brought tears to our eyes.",
      hi: "वाराणसी सहित गोल्डन ट्राइएंगल बेजोड़ था — हमारे चालक परिवार जैसे लगे, और निजी नौका से गंगा आरती ने हमें भावुक कर दिया।",
    },
    name: "Sarah & James W.",
    place: { en: "United Kingdom", hi: "यूनाइटेड किंगडम" },
  },
  {
    quote: {
      en: "Every hotel was a palace. Explore India planned our Rajasthan honeymoon down to the last detail — we simply enjoyed.",
      hi: "हर होटल एक महल था। एक्सप्लोर इंडिया ने हमारे राजस्थान हनीमून की हर बारीकी सँवार दी — हमने बस आनंद लिया।",
    },
    name: "Ananya & Rohan M.",
    place: { en: "Mumbai, India", hi: "मुंबई, भारत" },
  },
  {
    quote: {
      en: "As a photographer, their timing at every fort and ghat was perfect. The best tour company I have travelled with in India.",
      hi: "एक फोटोग्राफर के रूप में, हर किले और घाट पर उनका समय-निर्णय बेहतरीन था। भारत में मेरी सबसे अच्छी टूर कंपनी।",
    },
    name: "Marco D.",
    place: { en: "Milan, Italy", hi: "मिलान, इटली" },
  },
];

const Testimonials = () => {
  const { lang, t } = useLang();
  return (
    <section id="testimonials" className="relative py-24 sm:py-32 bg-ink/40 scroll-mt-20" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-8">
        <Reveal className="max-w-2xl">
          <Kicker>{t.testimonials.kicker}</Kicker>
          <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-medium tracking-tight text-slate-50">
            {t.testimonials.title}
          </h2>
        </Reveal>

        <div className="mt-16 grid md:grid-cols-3 gap-6 lg:gap-8">
          {REVIEWS.map((r, i) => (
            <Reveal key={r.name} delay={i * 0.12}>
              <figure
                data-testid={`testimonial-card-${i}`}
                className="h-full glass-card rounded-2xl border border-gold/15 p-8 hover:-translate-y-1 hover:border-gold/40 transition-all duration-500"
              >
                <Quote size={26} className="text-gold/60" />
                <blockquote className="mt-5 text-sm sm:text-base text-slate-300 leading-relaxed">
                  “{r.quote[lang]}”
                </blockquote>
                <figcaption className="mt-6 pt-5 border-t border-gold/10">
                  <p className="font-display text-lg text-slate-100">{r.name}</p>
                  <p className="text-xs uppercase tracking-[0.2em] text-gold/80 font-mono mt-1">{r.place[lang]}</p>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
